export default __webpack_public_path__ + "static/media/cryptocraft.53997b24.png";